














import { Vue, Component, Mixins } from "vue-property-decorator";
import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  option: any = {
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c}次"
    },
    grid: {
      left: "20%"
    },
    legend: {
      orient: "vertical",
      x: "left",
      data: []
    },
    xAxis: {
      type: "value"
    },
    yAxis: {
      type: "category",
      data: [],
      inverse: true
    },
    series: [
      {
        type: "bar",
        data: [],
        label: {
          show: true,
          position: "right"
        }
      }
    ]
  };
  ei: any = {};

  async mounted() {
    const res = await this.$store.dispatch("statistics/userPlayCount", {});
    if (res && res.Data) {
      this.option.series[0].data = [];
      this.option.yAxis.data = [];

      //   this.option.series[0].data = res.Data;

      for (const obj of res.Data) {
        this.option.yAxis.data.push(obj.username);
        this.option.series[0].data.push(obj.ccount);
      }
    }
  }
}
